import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { FormGroup, FormControl, Button, Row, Col, ControlLabel } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Moment from 'moment';
import './AuditLogFilters.css';

class AuditLogFilters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            ipAddress: props.filters.ipAddress || '',
            startDate: props.filters.startDate || '',
            endDate: props.filters.endDate || '',
            actionCategory: props.filters.actionCategory || '',
            action: props.filters.action || ''
        };
    }

    toggleExpanded = () => {
        this.setState({ expanded: !this.state.expanded });
    };

    handleChange = (field, value) => {
        this.setState({ [field]: value }, () => {
            // Auto-apply when actionCategory changes
            if (field === 'actionCategory') {
                this.handleApply();
            }
        });
    };

    handleDateChange = (field, momentDate) => {
        if (momentDate && Moment.isMoment(momentDate)) {
            this.setState({ [field]: momentDate.toISOString() });
        } else {
            this.setState({ [field]: '' });
        }
    };

    handleApply = () => {
        this.props.onFilterChange({
            ipAddress: this.state.ipAddress,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            actionCategory: this.state.actionCategory,
            action: this.state.action
        });
    };

    handleClear = () => {
        this.setState({
            ipAddress: '',
            startDate: '',
            endDate: '',
            actionCategory: '',
            action: ''
        });
        this.props.onFilterChange({
            ipAddress: '',
            startDate: '',
            endDate: '',
            actionCategory: '',
            action: ''
        });
    };

    render() {
        const { t } = this.props;
        const { expanded } = this.state;

        return (
            <div className="AuditLogFilters">
                <div className="filter-header">
                    <Button onClick={this.toggleExpanded} bsStyle="default">
                        <i className={`fa fa-${expanded ? 'chevron-up' : 'chevron-down'}`} />{' '}
                        {expanded ? t('AuditLogs.hideFilters') : t('AuditLogs.showFilters')}
                    </Button>
                </div>

                {expanded && (
                    <div className="filter-content">
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>{t('AuditLogs.startDate')}</ControlLabel>
                                    <Datetime
                                        value={this.state.startDate ? Moment(this.state.startDate) : ''}
                                        onChange={(date) => this.handleDateChange('startDate', date)}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm:ss"
                                        inputProps={{ placeholder: t('AuditLogs.startDate') }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>{t('AuditLogs.endDate')}</ControlLabel>
                                    <Datetime
                                        value={this.state.endDate ? Moment(this.state.endDate) : ''}
                                        onChange={(date) => this.handleDateChange('endDate', date)}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm:ss"
                                        inputProps={{ placeholder: t('AuditLogs.endDate') }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>{t('AuditLogs.actionCategory')}</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        value={this.state.actionCategory}
                                        onChange={(e) => this.handleChange('actionCategory', e.target.value)}
                                    >
                                        <option value="">{t('AuditLogs.allCategories')}</option>
                                        <option value="login">Authentication</option>
                                        <option value="create">Create/Add</option>
                                        <option value="update">Update/Modify</option>
                                        <option value="delete">Delete/Remove</option>
                                        <option value="read">Read/View</option>
                                        <option value="operation">Operation</option>
                                        <option value="checkin">Check-in</option>
                                    </FormControl>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>{t('AuditLogs.ipAddress')}</ControlLabel>
                                    <FormControl
                                        type="text"
                                        value={this.state.ipAddress}
                                        onChange={(e) => this.handleChange('ipAddress', e.target.value)}
                                        placeholder={t('AuditLogs.ipAddress')}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div className="filter-actions">
                                    <Button onClick={this.handleApply} bsStyle="primary">
                                        {t('AuditLogs.applyFilters')}
                                    </Button>
                                    {' '}
                                    <Button onClick={this.handleClear} bsStyle="default">
                                        {t('AuditLogs.clearFilters')}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        );
    }
}

export default translate('translations')(AuditLogFilters);
